import { useEffect } from 'react'
const FormaPago = (props) => {

    useEffect(() => {
        props.setEfe(props.total)
    }, [props.total])

    const validar = (valor, cual) => {
        const regex = /^(|\d+)$/

        if (regex.test(valor)) {
            if (parseInt(valor) > props.total) return
            if (cual === 'e') {
                props.setEfe(valor)
                props.setTrans(props.total - (valor !== '' ? parseInt(valor) : 0))
            }
            if (cual === 't') {
                props.setTrans(valor)
                props.setEfe(props.total - (valor !== '' ? parseInt(valor) : 0))
            }
        }
    }

    return (<>
        <div className='flex flex-row w-full justify-between'>
            <div className='flex flex-row justify-evenly w-1/2 mx-2'>
                <label className='mr-5'>Efectivo</label>
                <input
                    type='text'
                    className='w-20 text-right px-2'
                    value={props.efe}
                    onChange={e => validar(e.target.value, 'e')}
                />
            </div>
            <div className='flex flex-row justify-evenly w-1/2'>
                <label className='mr-5'>Transferencia</label>
                <input
                    type='text'
                    className='w-20 text-right px-2'
                    value={props.trans}
                    onChange={e => validar(e.target.value, 't')}
                />
            </div>
        </div>
    </>)
}

export default FormaPago